export const mainSection = {
  computed: {
    isNotMainSection () {
      return this.section.detailedComponent.length
    },
  },
}
